import Decimal, { format as DecimalFormat } from '@mixins/decimal';
import Model from '@models/model';
import PurchaseOrder from '@models/purchase-order';

export default class PurchaseItem extends Model {
    resource() {
        return 'purchase-items';
    }

    relations() {
        return {
            purchase_order: PurchaseOrder,
        };
    }

    get propCasts() {
        return {
            qty: Decimal,
        };
    }

    get formFieldCasts() {
        return {
            qty: DecimalFormat,
        };
    }

    get totalReceivedQty() {
        const sum = this.item_receipts.reduce((acc, current) => acc.plus(current.qty_received), new Decimal(0));

        return sum.toString();
    }
}
